import React from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { addBulkUser } from '../actions/Users';
import bulk from '../Res/Icon/bulk.png'
import { ReactComponent as BulkUsersSvg } from '../Res/bulkUsersSvg.svg'

export default function AddBulkUsers({ getUsersByRole }) {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();

  const handleAddBulkUser = async e => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('usersCSV', file);
      const res = await dispatch(addBulkUser(token, formData));
      if (res) {
        await getUsersByRole();
      }
    }
  };

  const uploadFile = () => {
    document.getElementById('file-input').click();
  };
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
    }}>
      <Button
        color="default"
        className="btn-circle btn-md"
        onClick={uploadFile}
        style={{
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#EAECEF',
        }}
      >
        <BulkUsersSvg width={50} height={50} />
      </Button>
      <input
        type="file"
        accept=".csv"
        style={{ display: 'none' }}
        onChange={handleAddBulkUser}
        id="file-input"
      />
    </div>
  );
}
